module.exports = "<app-breeds></app-breeds>"